import { NavigateFunction } from 'react-router-dom';
import { isLocalizedHomePath, localizePath } from '@/utils/languageRoutes';

export const scrollToTop = () => {
  requestAnimationFrame(() => {
    window.scrollTo({
      top: 0,
      behavior: 'instant'
    });
  });
};

export const scrollToServices = () => {
  const servicesSection = document.getElementById('services');
  if (servicesSection) {
    const headerHeight = 64;
    const elementPosition = servicesSection.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'instant'
    });
  }
};

export const handleHomeNavigation = (
  e: React.MouseEvent,
  navigate: NavigateFunction,
  currentPath: string,
  language: string,
  onMobileClick?: () => void
) => {
  e.preventDefault();
  if (onMobileClick) onMobileClick();

  if (isLocalizedHomePath(currentPath)) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  } else {
    navigate(localizePath('/', language), { replace: true });
    scrollToTop();
  }
};

export const handleServicesNavigation = (
  e: React.MouseEvent,
  navigate: NavigateFunction,
  currentPath: string,
  language: string,
  onMobileClick?: () => void
) => {
  e.preventDefault();
  if (!isLocalizedHomePath(currentPath)) {
    navigate(localizePath('/', language), { 
      replace: true,
      state: { scrollToServices: true }
    });
  } else {
    scrollToServices();
  }
  if (onMobileClick) onMobileClick();
};

export const handleAboutNavigation = (
  e: React.MouseEvent,
  navigate: NavigateFunction,
  language: string,
  onMobileClick?: () => void
) => {
  e.preventDefault();
  if (onMobileClick) onMobileClick();
  
  navigate(localizePath('/about', language), { replace: true });
  scrollToTop();
};
